import { styled } from '../../theme';

export const StyledSpan = styled('span')({});
